export const isLoggedSelector = (state) => state.authReducer.isLogged;
export const phoneSelector = (state) => state.authReducer.phone;
